import { ChangeDetectionStrategy, Component, input, output, signal } from "@angular/core";
import { IAlertComponent, IButtonDirective, IIconComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-bulk-upload-content",
  imports: [TranslocoDirective, IAlertComponent, IButtonDirective, IIconComponent],
  templateUrl: "./bulk-upload-content.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadContentComponent {
  bulkExample = input<string>("");
  fields = input<{ field: string; description: string }[] | undefined>(undefined);
  fileUploadError = input<string | undefined>(undefined);

  onTextareaUpload = output<string>();
  onCsvFileUpload = output<FileList | null>();

  textareaValue = signal("");

  textareaInputChange(event: Event) {
    this.textareaValue.set((event.target as HTMLTextAreaElement).value);
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      const textarea = event.target as HTMLTextAreaElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      textarea.value = textarea.value.substring(0, start) + "\t" + textarea.value.substring(end);
      textarea.selectionStart = textarea.selectionEnd = start + 1;
    }
  }
}
